import { ResolveFn } from '@angular/router';
import { inject } from '@angular/core';
import { CompanyStripe } from '../interface/company.interface';
import { SupabaseService } from '../service/supabase.service';

export const stripeAccountResolver: ResolveFn<CompanyStripe | 'error'> = async (route, state) => {
  
  const supabaseSerivce = inject(SupabaseService);

  return await supabaseSerivce.getCompanyStripeAccount()
  
};